import i18n from '@/i18n'

const HAS_CJK = /[\u4e00-\u9fff]/

/** 后端常见中文 message → common.apiErrors 键（键与原文一致，便于对照） */
const EXACT_KEYS = [
  '未登录', '登录已过期', '无效身份', '认证失效，请重新连接钱包',
  '请求失败', '服务器响应格式错误', '请先输入授权码',
  '用户不存在', '功能已关闭', '参数不完整', '无权操作', '无权查看',
  '余额不足', '用户余额不足，无法申请该算力', '可用余额不足', '可提现余额不足',
  '金额无效', '兑出与兑入不能是相同币种', '兑入数量过小', '报价失败', '闪兑失败',
  '申购成功', '申购金额无效', '理财产品不存在', '理财产品不存在或已停用', '活期产品已下线',
  '赎回成功', '持仓不存在', '该持仓已结束', '当前产品不可赎回',
  '资金密码错误', '资金密码设置成功', '资金密码修改成功', '请先设置资金密码',
  '旧密码不正确', '两次输入的密码不一致', '两次输入的新密码不一致',
  '提现金额不正确', '您的提现申请已提交，请等待审核',
  '您还有待处理的提现申请，请等待处理完成后再提交新申请',
  '已提交，请等待审核', '订单不存在', '请上传图片', '请上传转账凭证图片',
  '不支持的充值币种', '该币种不支持手动充值', '该交易哈希已提交过',
  '手动充值请等待后台审核', '已触发链上监控',
  '钱包地址格式不正确', '缺少验签参数', '签名挑战已失效，请重新发起登录', '签名校验失败',
  '已退出登录', '授权码未启用', '授权码错误', '验证成功',
  '请上传文件', '认证等级无效', '您已完成 Lv1 认证', '您已完成 Lv2 认证',
  '请先完成 Lv1 认证', '您有待审核的认证申请，请等待审核完成',
  '未找到已通过的 Lv1 资料', '请上传本人与证件同框视频',
  '请填写姓名和证件号', '请填写有效邮箱', '请上传证件正反面',
  '认证申请已提交，请等待审核', '请上传完整的身份证件图片',
  '借贷产品不存在', '借款金额不正确', '借款天数不正确', '请输入姓名', '请输入手机号',
  '借款申请已提交，请等待审核',
  '未找到该币种', '方向无效', '资产不可用', '周期不可用', '交易标的不可用',
  '抽奖次数不足', '暂无奖品配置',
  '申请不存在', '申请已提交', '算力配置不存在', '算力申请不存在',
  '算力未到期，暂不可申请赎回', '当前算力申请尚未通过，暂不可赎回',
  '您已有待处理的赎回申请', '请输入有效的申请金额',
  'AI 产品不存在', 'AI 订单不存在', '最低投入金额为100',
  '最多同时持有5个AI交易订单', '仅运行中订单可停止', '仅待审核订单可取消',
  '当前状态不可取消', '无效的风险类型', '内容不能为空', '消息不存在',
  '种子已领取', '浇水成功', '帮浇成功', '好友添加成功', '已删除好友',
  '加息卡已兑换，购买理财时可用',
  'TRON 钱包验签将在第二阶段接入', '未检测到可用的 EVM 钱包',
  'kyc_required', 'has_unpaid_loan'
]

const PATTERNS = [
  [/^最低申购\s*(.+)$/, '最低申购', (m) => ({ amount: m[1] })],
  [/^最高申购\s*(.+)$/, '最高申购', (m) => ({ amount: m[1] })],
  [/^该产品限购\s*(\d+)\s*次，您已购买\s*(\d+)\s*次$/, '该产品限购次数', (m) => ({ max: m[1], bought: m[2] })]
]

function te (key) {
  try {
    return i18n.global.te(key) || i18n.global.te(key, 'en')
  } catch (_) {
    return false
  }
}

function t (key, values) {
  try {
    return i18n.global.t(key, values)
  } catch (_) {
    return key
  }
}

/**
 * 把后端中文 message 转成当前语言文案；未知中文则回落通用失败提示，避免英文界面冒出中文。
 */
export function translateApiMessage (message, fallbackKey = 'common.apiErrors.请求失败') {
  if (message == null || message === '') return t(fallbackKey)
  const raw = String(message).trim()
  if (!raw) return t(fallbackKey)

  const exactKey = `common.apiErrors.${raw}`
  if (te(exactKey)) return t(exactKey)

  // 兼容 farm.apiErrors（去掉空白后的键）
  const farmKey = `farm.apiErrors.${raw.replace(/\s+/g, '')}`
  if (te(farmKey)) return t(farmKey)

  const assetsKey = `assets.${raw}`
  if (te(assetsKey)) return t(assetsKey)

  for (const [re, key, vars] of PATTERNS) {
    const m = raw.match(re)
    if (m) {
      const k = `common.apiErrors.${key}`
      if (te(k)) return t(k, vars(m))
    }
  }

  // 英文或其他语言原文直接返回；中文未知文案不透传
  if (HAS_CJK.test(raw)) return t(fallbackKey)
  return raw
}

export function ensureApiErrorCatalog () {
  return EXACT_KEYS
}
